<div class="wrap-m wrap-s">
    <login-form-retail [content]="content"
                       *ifNotTradeStore></login-form-retail>

    <login-form-trade [content]="content"
                      *ifTradeStore></login-form-trade>
</div>